$(function() {

    // @vars -----------------------------------------------------------------------------------------------------------
    var $sliderHomeEl = $('.slider-home'),
        $sliderHomePager = $sliderHomeEl.find('.slider-controls-pager'),
        sliderHomeInstance,
        autostart = $('#hero-block-preferences').data('slider-autostart') === 1 && $(window).width() >= 992,
        startSlide = $('#hero-block-preferences').data('start-slide');

    // @initializations ------------------------------------------------------------------------------------------------
    sliderHomeInstance = $('.slider', $sliderHomeEl).bxSlider({
        auto: autostart,
        startSlide: startSlide,
        nextSelector: '.slider-controls-next',
        nextText: '',
        pager: false,
        pause: 7000,
        speed: 500,
        prevSelector: '.slider-controls-prev',
        prevText: '',
        touchEnabled: false,

        onSliderLoad: function() {
            $('.slider-fouc').css({
                'overflow': 'visible',
                'visibility': 'visible',
                'height': 'auto'
            });
            $sliderHomePager.find('[data-slide-index="' + startSlide + '"]').toggleClass('active', true);
        },

        onSlideBefore: function($slideEl, i, j) {
            $sliderHomePager
                .find('a').removeClass('active').end()
                .find('[data-slide-index="' + j + '"]').toggleClass('active', true);
        }
    });

    // @events ---------------------------------------------------------------------------------------------------------
    $sliderHomePager.find('a').on('click', function(e) {
        e.preventDefault();
        sliderHomeInstance.stopAuto();
        sliderHomeInstance.goToSlide($(this).data('slide-index'));
    });

    $('.slider-controls-prev, .slider-controls-next').on('click', function() {
        sliderHomeInstance.stopAuto();
    });

    $(document).on('click', 'a[href^="#"]', function(eventObj) {
        var href = $(this).attr('href');
        var $domObj = $(href);

        if ('#' === href || $domObj.length === 0) {
            return;
        }

        eventObj.preventDefault();

        $('html, body').animate({
            scrollTop: $(href).offset().top
        }, 'slow');
    });

    $('.slider-slide-home-contents a').on('click', function(e) {
        var href = $(this).attr('href');
        window.location.href = href;
    });

    // @functions
    // -----------------------------------------------------------------------------------------------------------------
    function sendData(data) {
        return $.ajax({
            url: CCM_REL + '/index.php/tools/packages/hero_block_tool/ajax.php',
            data: data,
            type: 'POST',
            dataType: 'json'
        });
    }
});
